import React from "react";
import {
  Box,
  Paper,
  Typography,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: "2rem",
  },
  paper: {
    backgroundColor: "transparent",
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    marginBottom: "1.5rem",
    color: "#333333",
  },
  tableContainer: {
    width: "100%",
    maxWidth: "100%",
    overflowX: "auto",
    border: "1px solid #e0e0e0",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    margin: 0,
  },
  tableHeader: {
    backgroundColor: "#f0f0f0",
    fontFamily: "Satoshi-Bold",
    padding: "12px",
    borderBottom: "2px solid #ddd",
    fontSize: "0.875rem"
    // whiteSpace: "nowrap",
  },
  tableCell: {
    padding: "12px",
    borderBottom: "1px solid #e0e0e0",
    fontSize: "0.75rem",
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  emptyMessage: {
    textAlign: "center",
    padding: "2rem",
    color: "#999999",
    fontSize: "14px",
  },
}));

export default function Neutrals({ neutralsData = {} }) {
  const classes = useStyles();

  // Extract table data from neutralsData
  const tableData = React.useMemo(() => {
    if (neutralsData?.data && Array.isArray(neutralsData.data)) {
      return neutralsData?.data[0]?.table?.[0] || null;
    }
    return null;
  }, [neutralsData]);

  const title = React.useMemo(() => {
    if (neutralsData?.data && Array.isArray(neutralsData.data)) {
      return neutralsData.data[0]?.title || "Neutrals";
    }
    return "Neutrals";
  }, [neutralsData]);

  if (!tableData || !tableData.headers || !tableData.rows) {
    return (
      <Box className={classes.root}>
        <Paper className={classes.paper}>
          <Typography className={classes.title}>Neutrals</Typography>
          <Box className={classes.emptyMessage}>No data available</Box>
        </Paper>
      </Box>
    );
  }

  return (
    <Box className={classes.root}>
      <Paper className={classes.paper}>
        <Typography className={classes.title}>{title}</Typography>

        <TableContainer className={classes.tableContainer}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                {tableData.headers.map((header, index) => (
                  <TableCell key={index} className={classes.tableHeader}>
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.rows.map((row, rowIndex) => (
                <TableRow key={rowIndex} className={classes.tableRow}>
                  {row.map((cell, cellIndex) => (
                    <TableCell key={cellIndex} className={classes.tableCell}>
                      {cell}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}
